import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import {
  GetNotificationsCategoryEnum,
  PatientPortalNotificationControllerApi,
} from "../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getXtenantId,
  useBaseContent,
} from "../../utils/utils";

interface Props {
  patientUuid: string;
  pagination: DGT_Pagination;
  category?: GetNotificationsCategoryEnum;
  isRead?: boolean;
}

export const useGetPatientPortalNotifications = ({
  patientUuid,
  pagination,
  category,
  isRead,
}: Props): useBaseContent<any> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: "",
    prevPage,
  });

  return useQuery({
    queryKey: [
      "patient-portal-notifications",
      patientUuid,
      pagination,
      category,
      isRead,
    ],
    enabled: !!patientUuid,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    retry: (failureCount) => failureCount < 2,
    queryFn: async () =>
      await new PatientPortalNotificationControllerApi(getConfigObject())
        .getNotifications(
          patientUuid,
          category,
          isRead,
          pageIndex,
          pagination.pageSize,
          undefined,
          undefined,
          getXtenantId() ?? undefined
        )
        .then((res) => res?.data),
  });
};
